'use strict';
module.exports = (promise, onFinally) => {
	onFinally = onFinally || (() => {});

	return promise.then(
		val => new Promise(resolve => {
			resolve(onFinally());
		}).then(() => val),
		err => new Promise(resolve => {
			resolve(onFinally());
		}).then(() => {
			throw err;
		})
	);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/p-finally/index.js
// module id = ../node_modules/p-finally/index.js
// module chunks = 5